import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logod.png'
import _imports_1 from '../assets/img/u16.png'
import _imports_2 from '../assets/img/u61.png'
import _imports_3 from '../assets/img/u63.png'
import _imports_4 from '../assets/img/new.png'
import _imports_5 from '../assets/img/u62.png'
import _imports_6 from '../assets/img/u21.png'
import _imports_7 from '../assets/img/u25.png'
import _imports_8 from '../assets/img/u30.png'
import _imports_9 from '../assets/img/停止回答.png'
import _imports_10 from '../assets/img/remove1.png'
import _imports_11 from '../assets/img/remove.png'
import _imports_12 from '../assets/img/u66.png'
import _imports_13 from '../assets/img/u42.png'
import _imports_14 from '../assets/img/u99.png'
import _imports_15 from '../assets/img/u41.png'
import _imports_16 from '../assets/img/u43.png'
import _imports_17 from '../assets/img/copy_n.png'
import _imports_18 from '../assets/img/close.png'
import _imports_19 from '../assets/img/search.png'
import _imports_20 from '../assets/img/eye.png'
import _imports_21 from '../assets/img/time.png'
import _imports_22 from '../assets/img/quesheng.png'


const _withScopeId = n => (_pushScopeId("data-v-849e2e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "common-layout",
  style: {"background-color":"#fff"},
  ref: "aside"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"22px"} }, "ChatChats 畅聊")
], -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "product-card"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "product-card__imgbox" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "product-card__titles" }
const _hoisted_10 = {
  class: "aside",
  style: {"color":"#333"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"width":"20px","margin-right":"10px","margin-left":"5px"}
}, null, -1))
const _hoisted_13 = ["data-id", "onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {"width":"20px","margin-right":"10px","margin-left":"5px"}
}, null, -1))
const _hoisted_16 = { style: {"padding-left":"10px"} }
const _hoisted_17 = ["data-id", "data-name", "onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  style: {"margin-left":"20px"},
  src: _imports_4
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {"width":"20px","margin-right":"10px","margin-left":"5px"}
}, null, -1))
const _hoisted_21 = ["data-id", "onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"20px"},
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"20px"},
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"20px"},
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_26 = {
  key: 0,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_27 = {
  class: "item_card1",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, " 聊天记录 ")
], -1))
const _hoisted_29 = {
  style: {"width":"100%","height":"calc(100% - 41px)","overflow-y":"auto"},
  ref: "historyheight"
}
const _hoisted_30 = {
  key: 0,
  class: "historyselect"
}
const _hoisted_31 = ["data-id", "onClick"]
const _hoisted_32 = ["src"]
const _hoisted_33 = ["data-id"]
const _hoisted_34 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_35 = ["data-id"]
const _hoisted_36 = { class: "mychat_del_div" }
const _hoisted_37 = ["data-id", "onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["data-id"]
const _hoisted_40 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_41 = { style: {"font-size":"14px"} }
const _hoisted_42 = ["data-id"]
const _hoisted_43 = { class: "mychat_del_div" }
const _hoisted_44 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_45 = { class: "card1" }
const _hoisted_46 = {
  class: "item_card",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_47 = {
  class: "card_clum",
  style: {"width":"100%"}
}
const _hoisted_48 = { class: "text item" }
const _hoisted_49 = {
  class: "answer",
  style: {"width":"100%","margin-bottom":"0","max-width":"100%"}
}
const _hoisted_50 = { class: "moreanswer" }
const _hoisted_51 = { class: "card-header" }
const _hoisted_52 = {
  key: 0,
  class: "qus"
}
const _hoisted_53 = { style: {"white-space":"pre-wrap"} }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { style: {"color":"#595757","white-space":"pre-wrap"} }
const _hoisted_56 = {
  key: 2,
  class: "answer",
  style: {"max-width":"88%"}
}
const _hoisted_57 = ["src"]
const _hoisted_58 = {
  class: "markdown-body",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = {
  key: 0,
  class: "qus"
}
const _hoisted_61 = { style: {"white-space":"pre-wrap"} }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { style: {"white-space":"pre-wrap","color":"#595757"} }
const _hoisted_64 = {
  key: 2,
  class: "answer",
  style: {"max-width":"88%"}
}
const _hoisted_65 = ["src"]
const _hoisted_66 = {
  class: "markdown-body",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "icon-box" }
const _hoisted_70 = {
  key: 0,
  class: "pagination"
}
const _hoisted_71 = { class: "subs" }
const _hoisted_72 = {
  key: 0,
  class: "qus"
}
const _hoisted_73 = { style: {"white-space":"pre-wrap"} }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { style: {"color":"#595757","white-space":"pre-wrap"} }
const _hoisted_76 = {
  key: 2,
  class: "answer",
  style: {"max-width":"88%"}
}
const _hoisted_77 = ["src"]
const _hoisted_78 = {
  class: "markdown-body",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "icon-box" }
const _hoisted_82 = {
  key: 0,
  class: "pagination"
}
const _hoisted_83 = { class: "subs" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "停止回答",
  class: "",
  style: {"width":"25px","height":"25px","margin-right":"10px","cursor":"pointer"},
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "停止回答",
  class: "",
  style: {"width":"25px","height":"25px","margin-right":"10px","cursor":"pointer"},
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_88 = {
  key: 0,
  class: "qus"
}
const _hoisted_89 = { style: {"white-space":"pre-wrap"} }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { style: {"color":"#595757","white-space":"pre-wrap"} }
const _hoisted_92 = {
  key: 2,
  class: "answer",
  style: {"max-width":"88%"}
}
const _hoisted_93 = ["src"]
const _hoisted_94 = {
  class: "markdown-body",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = { class: "card_input step12" }
const _hoisted_97 = { class: "newchatshow step13" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "newchatimg",
  style: {"width":"30px","margin-right":"10px","cursor":"pointer"},
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_99 = {
  class: "card_input_input",
  style: {"position":"relative","width":"800px","max-width":"800px"}
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {"width":"24px","height":"24px"},
  alt: ""
}, null, -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = {
  key: 2,
  style: {"height":"100%"}
}
const _hoisted_103 = { class: "card" }
const _hoisted_104 = {
  class: "item_card item_card2",
  style: {"width":"100%","height":"100%","display":"flex","justify-content":"space-between","flex-wrap":"wrap"}
}
const _hoisted_105 = { class: "card-header" }
const _hoisted_106 = {
  key: 0,
  class: "card_clum"
}
const _hoisted_107 = {
  class: "text item",
  ref: "questionref"
}
const _hoisted_108 = {
  key: 0,
  class: "qus"
}
const _hoisted_109 = { style: {"white-space":"pre-wrap"} }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { style: {"color":"#595757","white-space":"pre-wrap"} }
const _hoisted_112 = {
  key: 2,
  class: "answer",
  style: {"max-width":"88%"}
}
const _hoisted_113 = ["src"]
const _hoisted_114 = {
  class: "markdown-body",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_115 = ["innerHTML"]
const _hoisted_116 = {
  key: 1,
  class: "card_clum"
}
const _hoisted_117 = {
  class: "text item",
  ref: "questionref"
}
const _hoisted_118 = {
  key: 0,
  class: "qus"
}
const _hoisted_119 = { style: {"white-space":"pre-wrap"} }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { style: {"color":"#595757","white-space":"pre-wrap"} }
const _hoisted_122 = {
  key: 2,
  class: "answer"
}
const _hoisted_123 = ["src"]
const _hoisted_124 = {
  class: "markdown-body content-box",
  style: {"background-color":"#f2f2f2","padding":"10px"}
}
const _hoisted_125 = ["innerHTML"]
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { class: "icon-box" }
const _hoisted_128 = {
  key: 0,
  class: "pagination"
}
const _hoisted_129 = { class: "subs" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "停止回答",
  class: "",
  style: {"width":"25px","height":"25px","margin-right":"10px","cursor":"pointer"},
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_131 = { class: "card-header" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"32px"} }, " 机器人详情 ", -1))
const _hoisted_133 = { class: "robotinfo_name" }
const _hoisted_134 = {
  key: 0,
  class: "robotinfo_button"
}
const _hoisted_135 = {
  key: 1,
  style: {"margin-top":"10px","font-size":"14px","color":"#666"}
}
const _hoisted_136 = { style: {"margin-top":"10px"} }
const _hoisted_137 = {
  key: 1,
  class: "card_input"
}
const _hoisted_138 = {
  class: "card_input_input",
  style: {"width":"800px","max-width":"800px"}
}
const _hoisted_139 = {
  key: 0,
  class: "out_box1"
}
const _hoisted_140 = ["placeholder"]
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {"width":"24px","height":"24px"},
  alt: ""
}, null, -1))
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = {
  key: 2,
  class: "card_input"
}
const _hoisted_144 = { class: "newchatshow" }
const _hoisted_145 = {
  class: "newchatimg",
  style: {"width":"30px","margin-right":"10px","cursor":"pointer"},
  src: _imports_11,
  alt: ""
}
const _hoisted_146 = {
  class: "card_input_input",
  style: {"width":"800px","max-width":"800px"}
}
const _hoisted_147 = {
  key: 0,
  class: "out_box1"
}
const _hoisted_148 = ["placeholder"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {"width":"24px","height":"24px"},
  alt: ""
}, null, -1))
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = {
  key: 3,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_152 = {
  class: "item_card item_card1",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_153 = {
  style: {"width":"100%","height":"100%","overflow-y":"auto"},
  class: "step4"
}
const _hoisted_154 = {
  class: "card_input_robot step2",
  style: {"max-width":"1200px","display":"flex","flex-wrap":"wrap"}
}
const _hoisted_155 = ["onClick"]
const _hoisted_156 = ["src"]
const _hoisted_157 = {
  style: {"position":"absolute","top":"-10px","right":"-11px","width":"22px"},
  src: _imports_4
}
const _hoisted_158 = {
  class: "card_input_input step3",
  style: {"margin-left":"10px","width":"1200px","max-width":"1200px"}
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {"width":"24px","height":"24px"},
  alt: ""
}, null, -1))
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = {
  class: "card_input_input1",
  style: {"margin-left":"10px"}
}
const _hoisted_162 = {
  key: 0,
  class: "card_input_input1_active"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择机器人    ", -1))
const _hoisted_164 = ["src"]
const _hoisted_165 = { key: 1 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择机器人", -1))
const _hoisted_167 = [
  _hoisted_166
]
const _hoisted_168 = { class: "card_select step1" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card_select_p" }, "应用场景", -1))
const _hoisted_170 = { class: "card_select_div_tab" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = {
  key: 0,
  class: "card_select_div",
  style: {"margin-top":"0"}
}
const _hoisted_173 = { style: {"color":"#595757","max-width":"540px"} }
const _hoisted_174 = ["data-id", "onClick"]
const _hoisted_175 = { style: {"text-align":"center"} }
const _hoisted_176 = { style: {"font-size":"14px","color":"#c4c4c4"} }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_select_item_btns" }, "添加为机器人", -1))
const _hoisted_178 = {
  key: 0,
  class: "card_select"
}
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card_select_p" }, "我创建的", -1))
const _hoisted_180 = { class: "card_select_div" }
const _hoisted_181 = { style: {"color":"#595757","max-width":"540px"} }
const _hoisted_182 = ["data-id", "onClick"]
const _hoisted_183 = { style: {"text-align":"center"} }
const _hoisted_184 = { style: {"font-size":"14px","color":"#c4c4c4"} }
const _hoisted_185 = {
  class: "item_card",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","font-size":"18px","font-weight":"600","margin-bottom":"30px","color":"#333"} }, " 智能聊天新体验 ", -1))
const _hoisted_187 = {
  class: "card_input_robot",
  style: {"margin":"0 auto","width":"1200px","display":"flex","flex-wrap":"wrap"}
}
const _hoisted_188 = ["src"]
const _hoisted_189 = {
  class: "card_input_input",
  style: {"margin":"10px auto","width":"1200px","max-width":"1200px"}
}
const _hoisted_190 = {
  class: "inputs",
  style: {"border":"none"}
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {"width":"24px","height":"24px"},
  alt: ""
}, null, -1))
const _hoisted_192 = [
  _hoisted_191
]
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_input_bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card_input_bottom_item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_13,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("p", null, "多科学模型"),
      /*#__PURE__*/_createElementVNode("p", null, "提供多种信息平台")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card_input_bottom_item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_14,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("p", null, "双模型对比"),
      /*#__PURE__*/_createElementVNode("p", null, "获取更理想的信息")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card_input_bottom_item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_15,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("p", null, "预设大模型"),
      /*#__PURE__*/_createElementVNode("p", null, "方便用户快捷提问")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card_input_bottom_item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_16,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("p", null, "自建机器人"),
      /*#__PURE__*/_createElementVNode("p", null, "创建定制化的方案")
    ])
  ])
], -1))
const _hoisted_194 = {
  key: 3,
  class: "bottom_info"
}
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "北京盈科千信科技有限公司", -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "地址：北京市海淀区中关村南大街48号", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邮箱：product@increscence.net", -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Copyright © 2024"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_17,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("京ICP备15054044号-1 ")
], -1))
const _hoisted_199 = [
  _hoisted_195,
  _hoisted_196,
  _hoisted_197,
  _hoisted_198
]
const _hoisted_200 = { style: {"width":"70%","margin":"0 auto"} }
const _hoisted_201 = { style: {"text-align":"center"} }
const _hoisted_202 = { style: {"width":"90%","margin":"0 auto"} }
const _hoisted_203 = { style: {"margin":"0 auto"} }
const _hoisted_204 = { class: "card-header" }
const _hoisted_205 = {
  style: {"overflow-y":"auto","height":"65vh"},
  class: "myrobot"
}
const _hoisted_206 = { style: {"margin":"10px","font-weight":"600","font-size":"16px"} }
const _hoisted_207 = ["data-id", "onClick"]
const _hoisted_208 = ["src"]
const _hoisted_209 = { style: {"margin":"10px","font-weight":"600","font-size":"16px"} }
const _hoisted_210 = { style: {"padding-left":"10px"} }
const _hoisted_211 = { style: {"margin":"10px","font-weight":"600","font-size":"16px"} }
const _hoisted_212 = ["data-id", "data-name", "onClick"]
const _hoisted_213 = ["src"]
const _hoisted_214 = { style: {"margin":"10px","font-weight":"600","font-size":"16px"} }
const _hoisted_215 = ["data-id", "onClick"]
const _hoisted_216 = ["src"]
const _hoisted_217 = { class: "maskdialog step11" }
const _hoisted_218 = ["onClick"]
const _hoisted_219 = { class: "drawertop" }
const _hoisted_220 = { class: "drawerform" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "机器人名称", -1))
const _hoisted_222 = { class: "drawerform" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "选择大模型", -1))
const _hoisted_224 = { class: "drawerform" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "提示词", -1))
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "告诉你的机器人如何表现以及如何回应用户的消息。尽量说得具体些", -1))
const _hoisted_227 = { class: "drawerform" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在机器人简介中显示提示词", -1))
const _hoisted_229 = { class: "drawerform" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "问候语", -1))
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "机器人将在每次对话开始时发送消息", -1))
const _hoisted_232 = { class: "drawerform" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "机器人描述", -1))
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "可以简要描述机器人涉及的领域、主要功能及用途", -1))
const _hoisted_235 = { class: "promptdiv" }
const _hoisted_236 = ["src"]
const _hoisted_237 = { style: {"margin":"10px auto","font-size":"18px","font-weight":"600","text-align":"center"} }
const _hoisted_238 = { style: {"margin":"20px auto","font-size":"14px","font-weight":"600","text-align":"center"} }
const _hoisted_239 = { class: "select-dialog" }
const _hoisted_240 = { class: "select-header" }
const _hoisted_241 = { class: "select-header-div" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"32px"} }, " 选择机器人 ", -1))
const _hoisted_243 = { class: "select-header-center" }
const _hoisted_244 = { class: "select-header-input step8" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 0 10px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_19,
    alt: ""
  })
], -1))
const _hoisted_246 = {
  key: 0,
  class: "searchdialog"
}
const _hoisted_247 = {
  key: 0,
  class: "card_select_div_tab"
}
const _hoisted_248 = { class: "card_select_div" }
const _hoisted_249 = ["onClick", "data-id"]
const _hoisted_250 = { style: {"text-align":"center"} }
const _hoisted_251 = { style: {"font-size":"14px","color":"#c4c4c4"} }
const _hoisted_252 = { class: "card_select_item_text" }
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  alt: ""
}, null, -1))
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  alt: ""
}, null, -1))
const _hoisted_255 = {
  key: 0,
  class: "card_select_quesheng"
}
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_22,
  alt: ""
}, null, -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "没有找到对应机器人", -1))
const _hoisted_258 = [
  _hoisted_256,
  _hoisted_257
]
const _hoisted_259 = {
  key: 1,
  class: "searchdialog"
}
const _hoisted_260 = {
  key: 0,
  class: "card_select_div_tab step6"
}
const _hoisted_261 = ["onClick"]
const _hoisted_262 = {
  key: 1,
  class: "card_select_div",
  style: {"margin-top":"0","flex-wrap":"wrap","max-height":"57vh"}
}
const _hoisted_263 = ["data-id"]
const _hoisted_264 = { style: {"text-align":"center"} }
const _hoisted_265 = { style: {"font-size":"14px","color":"#c4c4c4"} }
const _hoisted_266 = { class: "card_select_item_text" }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  alt: ""
}, null, -1))
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  alt: ""
}, null, -1))
const _hoisted_269 = ["onClick"]
const _hoisted_270 = {
  key: 0,
  class: "card_select_quesheng"
}
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_22,
  alt: ""
}, null, -1))
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "没有找到对应机器人", -1))
const _hoisted_273 = [
  _hoisted_271,
  _hoisted_272
]
const _hoisted_274 = {
  key: 2,
  class: "card_select_div step9",
  style: {"margin-top":"0","flex-wrap":"wrap","max-height":"57vh"}
}
const _hoisted_275 = ["data-id"]
const _hoisted_276 = { style: {"text-align":"center"} }
const _hoisted_277 = { style: {"font-size":"14px","color":"#c4c4c4"} }
const _hoisted_278 = { class: "card_select_item_text" }
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  alt: ""
}, null, -1))
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  alt: ""
}, null, -1))
const _hoisted_281 = ["onClick"]
const _hoisted_282 = {
  key: 0,
  class: "card_select_quesheng"
}
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_22,
  alt: ""
}, null, -1))
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "没有找到对应机器人", -1))
const _hoisted_285 = [
  _hoisted_283,
  _hoisted_284
]
const _hoisted_286 = { class: "select-dialog" }
const _hoisted_287 = { class: "select-header" }
const _hoisted_288 = { class: "select-header-div" }
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"32px"} }, " 更新通知 ", -1))
const _hoisted_290 = { class: "titleandtime" }
const _hoisted_291 = { class: "vtitle" }
const _hoisted_292 = { class: "ttitle" }
const _hoisted_293 = { class: "titleandtime" }
const _hoisted_294 = ["innerHTML"]
const _hoisted_295 = { class: "register-container" }
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "register-tips" }, "注册教程", -1))
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "register-guide-text" }, " ①点击注册后，请先进行机构账号登录以验证您的机构身份（如未出现此界面，请忽略此步骤） ", -1))
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "register-guide-text" }, "②点击注册，输入对应个人信息进行注册", -1))
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "register-guide-text" }, " ③注册成功后，点击登录，输入账号密码后即可使用畅聊 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"height":"50px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                (_ctx.token)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      "confirm-button-text": "退出",
                      "cancel-button-text": "取消",
                      title: "退出登录？",
                      onConfirm: _ctx.confirmEvent
                    }, {
                      reference: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.username), 1)
                      ]),
                      _: 1
                    }, 8, ["onConfirm"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_el_button, {
                        type: "text",
                        style: {"font-size":"12px","color":"#959595"},
                        onClick: _ctx.registerHelp
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("注册教程")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.login
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("登录")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "",
                        onClick: _ctx.register
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("注册")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.token)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productCards, (opt, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    onClick: ($event: any) => (_ctx.openCardUrl(opt.role!, opt.path!))
                  }, [
                    (_ctx.userRole[opt.role])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['product-card-li', 'product-card-li-' + index])
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              src: opt.image_url
                            }, null, 8, _hoisted_8)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", null, _toDisplayString(opt.title_en), 1),
                            _createElementVNode("p", null, _toDisplayString(opt.title_cn), 1)
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_6))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.token)
          ? (_openBlock(), _createBlock(_component_el_container, {
              key: 1,
              class: "container"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_aside, { width: "280px" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "homebutton",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCreateDialog && _ctx.handleCreateDialog(...args)))
                      }, [
                        _hoisted_11,
                        _createTextVNode(" 创建新对话 ")
                      ]),
                      _createVNode(_component_el_collapse, { accordion: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_collapse_item, { name: "3" }, {
                            title: _withCtx(() => [
                              _hoisted_12,
                              _createTextVNode(" 基础模型 ")
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.asideList, (item, index) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["mychat", item.id === _ctx.infojson.json.id ? 'mychat_active' : '']),
                                  "data-type": "robot",
                                  "data-id": item.id,
                                  key: index,
                                  onClick: ($event: any) => (_ctx.tab(item, 'new-chat'))
                                }, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: _ctx.origin + item.logo,
                                    alt: ""
                                  }, null, 8, _hoisted_14), [
                                    [_vShow, item.logo]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                                ], 10, _hoisted_13)), [
                                  [_vShow, item.name]
                                ])
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { name: "2" }, {
                            title: _withCtx(() => [
                              _hoisted_15,
                              _createTextVNode(" 应用场景 ")
                            ]),
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_el_collapse, { accordion: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.maskList, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_collapse_item, {
                                      name: item.name,
                                      key: index
                                    }, {
                                      title: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.masks, (items, indexs) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "mychat sider-chat-item",
                                            "data-id": items.id,
                                            "data-name": items.title,
                                            "data-type": "mask",
                                            key: indexs,
                                            onClick: ($event: any) => (_ctx.masktab(items.id))
                                          }, [
                                            _withDirectives(_createElementVNode("img", {
                                              src: _ctx.origin + items.logo,
                                              alt: ""
                                            }, null, 8, _hoisted_18), [
                                              [_vShow, items.logo]
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(items.title) + " ", 1),
                                            _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                                              [_vShow, _ctx.mathnowtime(items.create_time)]
                                            ])
                                          ], 8, _hoisted_17))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]))
                                  }), 128))
                                ]),
                                _: 1
                              })), [
                                [_directive_loading, _ctx.maskrobotListdialog]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { name: "4" }, {
                            title: _withCtx(() => [
                              _hoisted_20,
                              _createTextVNode(" 我创建的 ")
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.myrobotList, (item, index) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  class: "mychat",
                                  "data-id": item.id,
                                  "data-type": "robot",
                                  key: index,
                                  onClick: ($event: any) => (_ctx.tab(item, 'new-chat'))
                                }, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: _ctx.origin + item.logo,
                                    alt: ""
                                  }, null, 8, _hoisted_22), [
                                    [_vShow, item.logo]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                                ], 8, _hoisted_21)), [
                                  [_vShow, item.name]
                                ])
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        draggable: "false",
                        class: "addrobot",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDrawer && _ctx.openDrawer(...args)))
                      }, [
                        _hoisted_23,
                        _createTextVNode(" 创建机器人 ")
                      ]),
                      _createElementVNode("div", {
                        draggable: "false",
                        class: "addrobot",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openmyrobotcard && _ctx.openmyrobotcard(...args)))
                      }, [
                        _hoisted_24,
                        _createTextVNode(" 我的机器人 ")
                      ]),
                      _createElementVNode("div", {
                        draggable: "false",
                        class: "addrobot",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.historychat('chat')))
                      }, [
                        _hoisted_25,
                        _createTextVNode(" 聊天记录 ")
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_main, { style: {"padding":"0"} }, {
                  default: _withCtx(() => [
                    (_ctx.rightshow == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                              class: "box-card",
                              "body-class": "box-card-body",
                              style: {"width":"100%"}
                            }, {
                              header: _withCtx(() => [
                                _hoisted_28
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_29, [
                                  (_ctx.historyshowselect.list?.name)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.historyselecttrue ? 'historyactive' : ''),
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.historyselectclick(_ctx.historyshowselect.list)))
                                        }, _toDisplayString(_ctx.historyshowselect.list.name), 3),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.historyselecttrue == false ? 'historyactive' : ''),
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.historyselectclick('all')))
                                        }, " 全部 ", 2)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.chatListse, (item, index) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      "data-id": item.id,
                                      class: "mychat",
                                      style: {"border-bottom":"1px solid #e4e7ed","width":"50%","margin":"0 auto"},
                                      onClick: _withModifiers(($event: any) => (_ctx.chatidopen(item)), ["stop"])
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.origin + item.logo,
                                        alt: "",
                                        style: {"width":"50px","height":"50px","background-color":"#fff"}
                                      }, null, 8, _hoisted_32),
                                      _createElementVNode("div", {
                                        "data-id": item.id,
                                        style: {"min-width":"calc(100% - 50px)"}
                                      }, [
                                        _createElementVNode("p", _hoisted_34, [
                                          _createTextVNode(_toDisplayString(item.robot_name) + " ", 1),
                                          _createElementVNode("span", null, [
                                            _createTextVNode(_toDisplayString(item.history.create_time), 1),
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ArrowRight)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _createElementVNode("p", {
                                          "data-id": item.id
                                        }, _toDisplayString(item.history.answer), 9, _hoisted_35)
                                      ], 8, _hoisted_33),
                                      _createElementVNode("div", {
                                        class: "mychat_del",
                                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_component_el_popconfirm, {
                                          width: "220",
                                          "confirm-button-text": "确定",
                                          "cancel-button-text": "取消",
                                          onConfirm: ($event: any) => (_ctx.delchats(item.id, index, _ctx.robot.chatListse)),
                                          "icon-color": "#626AEF",
                                          title: "删除该聊天"
                                        }, {
                                          reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createVNode(_component_el_icon, { color: "#2454FF" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_MoreFilled)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["onConfirm"])
                                      ])
                                    ], 8, _hoisted_31)), [
                                      [_vShow, item.robot_name && _ctx.historyselecttrue == true]
                                    ])
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.chatList, (item, index) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      "data-id": item.id,
                                      class: "mychat mychathistory",
                                      style: {"border-bottom":"1px solid #e4e7ed","width":"50%","margin":"0 auto"},
                                      key: index,
                                      onClick: _withModifiers(($event: any) => (_ctx.chatidopen(item)), ["stop"])
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.origin + item.logo,
                                        alt: "",
                                        style: {"width":"50px","height":"50px","background-color":"#fff"}
                                      }, null, 8, _hoisted_38),
                                      _createElementVNode("div", {
                                        "data-id": item.id,
                                        style: {"min-width":"calc(100% - 70px)"}
                                      }, [
                                        _createElementVNode("p", _hoisted_40, [
                                          _createTextVNode(_toDisplayString(item.robot_name), 1),
                                          _createElementVNode("span", _hoisted_41, [
                                            _createTextVNode(_toDisplayString(item.history.create_time), 1),
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ArrowRight)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _createElementVNode("p", {
                                          "data-id": item.id
                                        }, _toDisplayString(item.history.answer), 9, _hoisted_42)
                                      ], 8, _hoisted_39),
                                      _createElementVNode("div", {
                                        class: "mychat_del",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_component_el_popconfirm, {
                                          width: "220",
                                          "confirm-button-text": "确定",
                                          "cancel-button-text": "取消",
                                          onConfirm: ($event: any) => (_ctx.delchats(item.id, index, _ctx.robot.chatList)),
                                          "icon-color": "#626AEF",
                                          title: "删除该聊天"
                                        }, {
                                          reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createVNode(_component_el_icon, { color: "#2454FF" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_MoreFilled)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["onConfirm"])
                                      ])
                                    ], 8, _hoisted_37)), [
                                      [_vShow, item.robot_name && _ctx.historyselecttrue == false]
                                    ])
                                  }), 128))
                                ], 512)
                              ]),
                              _: 1
                            })), [
                              [_directive_loading, _ctx.chatpageloading]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.rightshow == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectrobotlist.list, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_card, {
                                          style: {"width":"49%","height":"100%","margin-bottom":"10px","border-radius":"20px","padding":"0 10px"},
                                          key: index
                                        }, {
                                          header: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_51, [
                                              _createElementVNode("span", null, [
                                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                                (_ctx.selectrobotlist.list.length == 1)
                                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                                      key: 0,
                                                      onClick: ($event: any) => (_ctx.addselectlist(item)),
                                                      plain: "",
                                                      class: "button",
                                                      style: {"margin-left":"5px"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" 添加对照模型 ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              (_ctx.selectrobotlist.list.length == 1)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.closemoretype(item)),
                                                    plain: "",
                                                    class: "button"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" 关闭对照模式 ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 1,
                                                    title: "关闭",
                                                    onClick: ($event: any) => (_ctx.closerobot(index)),
                                                    class: "button",
                                                    text: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_icon, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_CloseBold)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                            ])
                                          ]),
                                          default: _withCtx(() => [
                                            (_ctx.morechattype == 'robot' && index == 0)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: "text item",
                                                  ref_for: true,
                                                  ref: 'questionref' + index,
                                                  style: {"height":"inherit"}
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerTemp1, (item, index) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                      (item.qus && item.qus != '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                            _createElementVNode("div", _hoisted_53, _toDisplayString(item.qus), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (item.qus && item.qus == '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                            _createVNode(_component_el_divider, null, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_55, _toDisplayString(item.qus), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (
                                  item.answer.length > 0 && item.answer[0].text
                                )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                            _createElementVNode("img", {
                                                              src: _ctx.origin + item.logo,
                                                              alt: ""
                                                            }, null, 8, _hoisted_57),
                                                            _createElementVNode("div", _hoisted_58, [
                                                              _createElementVNode("div", {
                                                                style: {"overflow-x":"auto"},
                                                                innerHTML: item.answer[item.current].text
                                                              }, null, 8, _hoisted_59)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ], 512))
                                              : _createCommentVNode("", true),
                                            (
                              (_ctx.morechattype == 'chatandrobot' ||
                                _ctx.morechattype == 'chat') &&
                              index == 0
                            )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "text item",
                                                  ref_for: true,
                                                  ref: 'questionref' + index,
                                                  style: {"height":"inherit"}
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer[_ctx.robot_chat_id_one], (item, index) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                      (item.qus && item.qus != '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                            _createElementVNode("div", _hoisted_61, _toDisplayString(item.qus), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (item.qus && item.qus == '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                            _createVNode(_component_el_divider, null, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_63, _toDisplayString(item.qus), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (
                                  item.answer.length > 0 && item.answer[0].text
                                )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                            _createElementVNode("img", {
                                                              src: _ctx.origin + item.logo,
                                                              alt: ""
                                                            }, null, 8, _hoisted_65),
                                                            _createElementVNode("div", _hoisted_66, [
                                                              _createElementVNode("div", {
                                                                innerHTML: item.answer[item.current].text
                                                              }, null, 8, _hoisted_67),
                                                              (item.iconShow)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                                    _createVNode(_component_el_divider, {
                                                                      style: {"margin":"5px 0 8px 0"},
                                                                      "border-style": "dashed"
                                                                    }),
                                                                    _createElementVNode("div", _hoisted_69, [
                                                                      (item.answer.length > 1)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                                            _createVNode(_component_el_icon, {
                                                                              class: _normalizeClass(
                                            item.current === 0
                                              ? 'disable'
                                              : 'icon'
                                          ),
                                                                              size: 12,
                                                                              onClick: ($event: any) => (
                                            _ctx.handleAnswerChange(item, 'prev')
                                          )
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_ArrowLeft)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["class", "onClick"]),
                                                                            _createElementVNode("span", _hoisted_71, _toDisplayString(item.current + 1) + "/" + _toDisplayString(item.answer.length), 1),
                                                                            _createVNode(_component_el_icon, {
                                                                              class: _normalizeClass(
                                            item.current ===
                                            item.answer.length - 1
                                              ? 'disable'
                                              : 'icon'
                                          ),
                                                                              size: 12,
                                                                              onClick: ($event: any) => (
                                            _ctx.handleAnswerChange(item, 'next')
                                          )
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_ArrowRight)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["class", "onClick"])
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      _createVNode(_component_el_tooltip, {
                                                                        effect: "dark",
                                                                        content: "复制",
                                                                        placement: "top",
                                                                        "show-after": 200
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_el_icon, {
                                                                            class: "icon copy-btn",
                                                                            size: 18,
                                                                            "data-clipboard-text": 
                                            item.answer[item.current].text
                                          ,
                                                                            onClick: _ctx.handleCopy
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_CopyDocument)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["data-clipboard-text", "onClick"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024),
                                                                      _createVNode(_component_el_tooltip, {
                                                                        effect: "dark",
                                                                        content: "重新生成",
                                                                        placement: "top",
                                                                        "show-after": 200
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          (
                                            index ===
                                            _ctx.answer[_ctx.robot_chat_id_one].length - 1
                                          )
                                                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                                                key: 0,
                                                                                class: "icon",
                                                                                size: 18,
                                                                                onClick: ($event: any) => (_ctx.handleRegenerate(item, 2))
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_RefreshLeft)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1032, ["onClick"]))
                                                                            : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ])
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ], 512))
                                              : _createCommentVNode("", true),
                                            (_ctx.morechattype == 'chat' && index == 1)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "text item",
                                                  ref_for: true,
                                                  ref: 'questionref' + index,
                                                  style: {"height":"inherit"}
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer[_ctx.robot_chat_id_two], (item, index) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                      (item.qus && item.qus != '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                            _createElementVNode("div", _hoisted_73, _toDisplayString(item.qus), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (item.qus && item.qus == '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                                            _createVNode(_component_el_divider, null, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_75, _toDisplayString(item.qus), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (
                                  item.answer.length > 0 && item.answer[0].text
                                )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                            _createElementVNode("img", {
                                                              src: _ctx.origin + item.logo,
                                                              alt: ""
                                                            }, null, 8, _hoisted_77),
                                                            _createElementVNode("div", _hoisted_78, [
                                                              _createElementVNode("div", {
                                                                innerHTML: item.answer[item.current].text
                                                              }, null, 8, _hoisted_79),
                                                              (item.iconShow)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                                    _createVNode(_component_el_divider, {
                                                                      style: {"margin":"5px 0 8px 0"},
                                                                      "border-style": "dashed"
                                                                    }),
                                                                    _createElementVNode("div", _hoisted_81, [
                                                                      (item.answer.length > 1)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                                            _createVNode(_component_el_icon, {
                                                                              class: _normalizeClass(
                                            item.current === 0
                                              ? 'disable'
                                              : 'icon'
                                          ),
                                                                              size: 12,
                                                                              onClick: ($event: any) => (
                                            _ctx.handleAnswerChange(item, 'prev')
                                          )
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_ArrowLeft)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["class", "onClick"]),
                                                                            _createElementVNode("span", _hoisted_83, _toDisplayString(item.current + 1) + "/" + _toDisplayString(item.answer.length), 1),
                                                                            _createVNode(_component_el_icon, {
                                                                              class: _normalizeClass(
                                            item.current ===
                                            item.answer.length - 1
                                              ? 'disable'
                                              : 'icon'
                                          ),
                                                                              size: 12,
                                                                              onClick: ($event: any) => (
                                            _ctx.handleAnswerChange(item, 'next')
                                          )
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_ArrowRight)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["class", "onClick"])
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      _createVNode(_component_el_tooltip, {
                                                                        effect: "dark",
                                                                        content: "复制",
                                                                        placement: "top",
                                                                        "show-after": 200
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_el_icon, {
                                                                            class: "icon copy-btn",
                                                                            size: 18,
                                                                            "data-clipboard-text": 
                                            item.answer[item.current].text
                                          ,
                                                                            onClick: _ctx.handleCopy
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_CopyDocument)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["data-clipboard-text", "onClick"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024),
                                                                      _createVNode(_component_el_tooltip, {
                                                                        effect: "dark",
                                                                        content: "重新生成",
                                                                        placement: "top",
                                                                        "show-after": 200
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          (
                                            index ===
                                            _ctx.answer[_ctx.robot_chat_id_two].length - 1
                                          )
                                                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                                                key: 0,
                                                                                class: "icon",
                                                                                size: 18,
                                                                                onClick: ($event: any) => (_ctx.handleRegenerate(item, 3))
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_RefreshLeft)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1032, ["onClick"]))
                                                                            : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ])
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ], 512))
                                              : _createCommentVNode("", true),
                                            (
                              _ctx.morechattype == 'chat' && _ctx.nowsbeck && index == 0
                            )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 3,
                                                  class: "stopbutton",
                                                  onClick: ($event: any) => (_ctx.closebutton('more', index))
                                                }, [
                                                  _hoisted_85,
                                                  _createTextVNode("停止回答 ")
                                                ], 8, _hoisted_84))
                                              : _createCommentVNode("", true),
                                            (
                              _ctx.morechattype == 'chat' && _ctx.nowsbeck2 && index == 1
                            )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 4,
                                                  class: "stopbutton",
                                                  onClick: ($event: any) => (_ctx.closebutton('more', index))
                                                }, [
                                                  _hoisted_87,
                                                  _createTextVNode("停止回答 ")
                                                ], 8, _hoisted_86))
                                              : _createCommentVNode("", true),
                                            (
                              (_ctx.morechattype == 'robot' ||
                                _ctx.morechattype == 'chatandrobot') &&
                              index == 1
                            )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 5,
                                                  class: "text item",
                                                  ref_for: true,
                                                  ref: 'questionref' + index,
                                                  style: {"height":"inherit"}
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerTemp2, (item, index) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                      (item.qus && item.qus != '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                            _createElementVNode("div", _hoisted_89, _toDisplayString(item.qus), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (item.qus && item.qus == '开启全新对话')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                            _createVNode(_component_el_divider, null, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_91, _toDisplayString(item.qus), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (
                                  item.answer.length > 0 && item.answer[0].text
                                )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                            _createElementVNode("img", {
                                                              src: _ctx.origin + item.logo,
                                                              alt: ""
                                                            }, null, 8, _hoisted_93),
                                                            _createElementVNode("div", _hoisted_94, [
                                                              _createElementVNode("div", {
                                                                innerHTML: item.answer[item.current].text
                                                              }, null, 8, _hoisted_95)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ], 512))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("img", {
                                      title: "取消关联上文",
                                      class: "newchatimg1",
                                      style: {"width":"30px","margin-right":"10px","cursor":"pointer"},
                                      src: _imports_10,
                                      alt: "",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.opennewchat('more')))
                                    }),
                                    _hoisted_98
                                  ]),
                                  _createElementVNode("div", _hoisted_99, [
                                    _createElementVNode("div", {
                                      class: "out_box",
                                      style: _normalizeStyle(
                          _ctx.isinline
                            ? 'border:2px solid #416BE2;background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                            : 'background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                        ),
                                      onFocusin: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isinline = true)),
                                      onFocusout: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isinline = false)),
                                      ref: "homefocusin"
                                    }, [
                                      _createElementVNode("div", {
                                        class: "inputs",
                                        style: _normalizeStyle(
                            _ctx.isinline
                              ? 'border-color:transparent;'
                              : 'border-color:#b2b3b5'
                          )
                                      }, [
                                        _withDirectives(_createElementVNode("textarea", {
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.question) = $event)),
                                          onKeyup: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keydown2 && _ctx.keydown2(...args)), ["enter"])),
                                          ref: "inputText",
                                          placeholder: "点击“enter”发送，点击“shift+enter”换行",
                                          onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                          rows: "2"
                                        }, null, 544), [
                                          [_vModelText, _ctx.question]
                                        ]),
                                        _createElementVNode("div", {
                                          class: "subbtn",
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.moresendmessage()))
                                        }, _hoisted_101)
                                      ], 4)
                                    ], 36)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.rightshow == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("div", _hoisted_104, [
                              _createVNode(_component_el_card, {
                                class: "box-card",
                                "body-class": "box-card-body",
                                style: _normalizeStyle(
                    _ctx.robotinfo == true
                      ? 'width:calc(100% - 260px);'
                      : 'width:100%'
                  )
                              }, {
                                header: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_105, [
                                    _createElementVNode("span", {
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.robotinfo = true)),
                                      style: {"cursor":"pointer"}
                                    }, _toDisplayString(_ctx.infojson.json.name), 1),
                                    (_ctx.infojson.json.type != 1 && _ctx.chattype == 'chat')
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          type: "primary",
                                          plain: "",
                                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addselect('chat'))),
                                          class: "button step10"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" 开启对照 ")
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.infojson.json.type != 1 && _ctx.chattype == 'robot')
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 1,
                                          type: "primary",
                                          plain: "",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addselect('robot'))),
                                          class: "button step10"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" 开启对照 ")
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  (_ctx.chattype == 'robot')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                        _createElementVNode("div", _hoisted_107, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerTemp1, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                              (item.qus && item.qus != '开启全新对话')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                    _createElementVNode("div", _hoisted_109, _toDisplayString(item.qus), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.qus && item.qus == '开启全新对话')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                    _createVNode(_component_el_divider, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_111, _toDisplayString(item.qus), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.answer.length > 0 && item.answer[0].text)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                                    _createElementVNode("img", {
                                                      src: _ctx.origin + item.logo,
                                                      alt: ""
                                                    }, null, 8, _hoisted_113),
                                                    _createElementVNode("div", _hoisted_114, [
                                                      _createElementVNode("div", {
                                                        innerHTML: item.answer[item.current].text
                                                      }, null, 8, _hoisted_115)
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ], 512)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.chattype == 'chat')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                        _createElementVNode("div", _hoisted_117, [
                                          (_ctx.total > _ctx.answer[_ctx.robot_chat_id_one].length)
                                            ? (_openBlock(), _createElementBlock("p", {
                                                key: 0,
                                                style: {"text-align":"center","cursor":"pointer","margin-bottom":"10px","font-size":"14px"},
                                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.logmore && _ctx.logmore(...args)))
                                              }, " 加载更多 "))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer[_ctx.robot_chat_id_one], (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                              (item.qus && item.qus != '开启全新对话')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                    _createElementVNode("div", _hoisted_119, _toDisplayString(item.qus), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.qus && item.qus == '开启全新对话')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                    _createVNode(_component_el_divider, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_121, _toDisplayString(item.qus), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.answer.length > 0 && item.answer[0].text)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                                    _createElementVNode("img", {
                                                      src: _ctx.origin + item.logo,
                                                      alt: ""
                                                    }, null, 8, _hoisted_123),
                                                    _createElementVNode("div", _hoisted_124, [
                                                      _createElementVNode("div", {
                                                        innerHTML: item.answer[item.current].text
                                                      }, null, 8, _hoisted_125),
                                                      (item.iconShow)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                            _createVNode(_component_el_divider, {
                                                              style: {"margin":"5px 0 8px 0"},
                                                              "border-style": "dashed"
                                                            }),
                                                            _createElementVNode("div", _hoisted_127, [
                                                              (item.answer.length > 1)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                                    _createVNode(_component_el_icon, {
                                                                      class: _normalizeClass(
                                      item.current === 0 ? 'disable' : 'icon'
                                    ),
                                                                      size: 12,
                                                                      onClick: ($event: any) => (_ctx.handleAnswerChange(item, 'prev'))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_ArrowLeft)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["class", "onClick"]),
                                                                    _createElementVNode("span", _hoisted_129, _toDisplayString(item.current + 1) + "/" + _toDisplayString(item.answer.length), 1),
                                                                    _createVNode(_component_el_icon, {
                                                                      class: _normalizeClass(
                                      item.current === item.answer.length - 1
                                        ? 'disable'
                                        : 'icon'
                                    ),
                                                                      size: 12,
                                                                      onClick: ($event: any) => (_ctx.handleAnswerChange(item, 'next'))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_ArrowRight)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["class", "onClick"])
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              _createVNode(_component_el_tooltip, {
                                                                effect: "dark",
                                                                content: "复制",
                                                                placement: "top",
                                                                "show-after": 200
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_icon, {
                                                                    class: "icon copy-btn",
                                                                    size: 18,
                                                                    "data-clipboard-text": 
                                      item.answer[item.current].text
                                    ,
                                                                    onClick: _ctx.handleCopy
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_CopyDocument)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["data-clipboard-text", "onClick"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_el_tooltip, {
                                                                effect: "dark",
                                                                content: "重新生成",
                                                                placement: "top",
                                                                "show-after": 200
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (
                                      index ===
                                      _ctx.answer[_ctx.robot_chat_id_one].length - 1
                                    )
                                                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                                                        key: 0,
                                                                        class: "icon",
                                                                        size: 18,
                                                                        onClick: ($event: any) => (_ctx.handleRegenerate(item, 1))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_RefreshLeft)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ], 512),
                                        (_ctx.chattype == 'chat' && _ctx.nowsbeck)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "stopbutton",
                                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closebutton('none')))
                                            }, [
                                              _hoisted_130,
                                              _createTextVNode("停止回答 ")
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["style"]),
                              (_ctx.robotinfo)
                                ? (_openBlock(), _createBlock(_component_el_card, {
                                    key: 0,
                                    class: "robotinfo box-card infocard"
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_131, [
                                        _hoisted_132,
                                        _createVNode(_component_el_icon, {
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.robotinfo = false)),
                                          style: {"cursor":"pointer"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CloseBold)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_133, [
                                        _createVNode(_component_el_avatar, {
                                          size: 50,
                                          src: _ctx.origin + _ctx.infojson.json.logo
                                        }, null, 8, ["src"]),
                                        _createElementVNode("div", null, _toDisplayString(_ctx.infojson.json.name), 1)
                                      ]),
                                      (_ctx.infojson.json.is_del == 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_134, [
                                            _createVNode(_component_el_button, {
                                              size: "small",
                                              style: {"padding":"6px"},
                                              type: "primary",
                                              plain: "",
                                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.tab(_ctx.selectrobotlist.list[0], 'new-chat')))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("新建聊天")
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.infojson.json.is_collect == false)
                                              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                                  key: 0,
                                                  size: "small",
                                                  style: {"padding":"6px","width":"88px"},
                                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.collectrobot(_ctx.infojson.json.id, '1')))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_StarFilled)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode("关注")
                                                  ]),
                                                  _: 1
                                                }, 512)), [
                                                  [_vShow, _ctx.infojson.json.type != 1]
                                                ])
                                              : _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                                  key: 1,
                                                  size: "small",
                                                  style: {"padding":"6px"},
                                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.collectrobot(_ctx.infojson.json.id, '2')))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_icon, { style: {"color":"yelow","font-size":"18px"} }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_StarFilled)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode("取消关注")
                                                  ]),
                                                  _: 1
                                                }, 512)), [
                                                  [_vShow, _ctx.infojson.json.type != 1]
                                                ]),
                                            _withDirectives(_createVNode(_component_el_button, {
                                              size: "small",
                                              style: {"padding":"6px"},
                                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.editrobots(_ctx.infojson.json)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 编辑机器人 ")
                                              ]),
                                              _: 1
                                            }, 512), [
                                              [_vShow, _ctx.infojson.json.type == 1]
                                            ]),
                                            (_ctx.infojson.json.type == 1)
                                              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                                                  key: 2,
                                                  trigger: "click"
                                                }, {
                                                  dropdown: _withCtx(() => [
                                                    _createVNode(_component_el_dropdown_menu, null, {
                                                      default: _withCtx(() => [
                                                        (_ctx.infojson.json.prompt_is_publish == 2)
                                                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                              key: 0,
                                                              onClick: _ctx.lookpamart
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(" 查看提示词 ")
                                                              ]),
                                                              _: 1
                                                            }, 8, ["onClick"]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_el_dropdown_item, {
                                                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.removerobts(_ctx.infojson.json.id)))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("删除机器人")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_button, {
                                                      size: "small",
                                                      style: {"padding":"8px","margin-left":"10px"},
                                                      round: "",
                                                      title: "查看提示词"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_icon, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_MoreFilled)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.infojson.json.is_del == 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_135, _toDisplayString(_ctx.infojson.json.describe), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("p", _hoisted_136, [
                                        _createVNode(_component_el_button, {
                                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.openhistory(_ctx.infojson.json)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("查看与此机器人的所有聊天")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.chattype == 'robot')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                    _createElementVNode("div", _hoisted_138, [
                                      (_ctx.infojson.json.is_del == 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_139))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "out_box",
                                        style: _normalizeStyle(
                        _ctx.isinline
                          ? 'border:2px solid #416BE2;background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                          : 'background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                      ),
                                        onFocusin: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isinline = true)),
                                        onFocusout: _cache[32] || (_cache[32] = ($event: any) => (_ctx.isinline = false))
                                      }, [
                                        _createElementVNode("div", {
                                          class: "inputs",
                                          style: _normalizeStyle(
                          _ctx.isinline
                            ? 'border-color:transparent;'
                            : 'border-color:#b2b3b5'
                        )
                                        }, [
                                          _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.question) = $event)),
                                            onKeyup: _cache[28] || (_cache[28] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args)), ["enter"])),
                                            ref: "inputText",
                                            placeholder: 
                            _ctx.infojson.json.is_del == 1
                              ? '点击“enter”发送，点击“shift+enter”换行'
                              : '当前机器人已被删除，无法发送新消息'
                          ,
                                            onInput: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            rows: "2"
                                          }, null, 40, _hoisted_140), [
                                            [_vModelText, _ctx.question]
                                          ]),
                                          _createElementVNode("div", {
                                            class: "subbtn",
                                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.sendmessage()))
                                          }, _hoisted_142)
                                        ], 4)
                                      ], 36)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.chattype == 'chat')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                    _createElementVNode("div", _hoisted_144, [
                                      _withDirectives(_createElementVNode("img", {
                                        title: "取消关联上文",
                                        class: "newchatimg1",
                                        style: {"width":"30px","margin-right":"10px","cursor":"pointer"},
                                        src: _imports_10,
                                        alt: "",
                                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.opennewchat('one')))
                                      }, null, 512), [
                                        [_vShow, _ctx.infojson.json.is_del == 1]
                                      ]),
                                      _withDirectives(_createElementVNode("img", _hoisted_145, null, 512), [
                                        [_vShow, _ctx.infojson.json.is_del == 1]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_146, [
                                      (_ctx.infojson.json.is_del !== 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_147))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "out_box",
                                        style: _normalizeStyle(
                        _ctx.isinline
                          ? 'border:2px solid #416BE2;background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                          : 'background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                      ),
                                        onFocusin: _cache[38] || (_cache[38] = ($event: any) => (_ctx.isinline = true)),
                                        onFocusout: _cache[39] || (_cache[39] = ($event: any) => (_ctx.isinline = false))
                                      }, [
                                        _createElementVNode("div", {
                                          class: "inputs",
                                          style: _normalizeStyle(
                          _ctx.isinline
                            ? 'border-color:transparent;'
                            : 'border-color:#b2b3b5'
                        )
                                        }, [
                                          _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.question) = $event)),
                                            onKeyup: _cache[35] || (_cache[35] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keydown1 && _ctx.keydown1(...args)), ["enter"])),
                                            ref: "inputText",
                                            placeholder: 
                            _ctx.infojson.json.is_del == 1
                              ? '点击“enter”发送，点击“shift+enter”换行'
                              : '当前机器人已被删除，无法发送新消息'
                          ,
                                            onInput: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            rows: "2"
                                          }, null, 40, _hoisted_148), [
                                            [_vModelText, _ctx.question]
                                          ]),
                                          _createElementVNode("div", {
                                            class: "subbtn",
                                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.chatsendmessage()))
                                          }, _hoisted_150)
                                        ], 4)
                                      ], 36)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.rightshow == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                          _createElementVNode("div", _hoisted_152, [
                            _createElementVNode("div", _hoisted_153, [
                              _createElementVNode("div", _hoisted_154, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.modelslist, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    onClick: ($event: any) => (_ctx.homeselect(index)),
                                    class: _normalizeClass(
                      _ctx.homeactivelist.list[0] == index
                        ? 'active'
                        : _ctx.homeactivelist.list[1] == index
                        ? 'active1'
                        : ''
                    ),
                                    key: index,
                                    style: {"position":"relative"}
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.origin + item.logo,
                                      alt: ""
                                    }, null, 8, _hoisted_156),
                                    _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                    _withDirectives(_createElementVNode("img", _hoisted_157, null, 512), [
                                      [_vShow, _ctx.mathnowtime(item.create_time)]
                                    ])
                                  ], 10, _hoisted_155))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_158, [
                                _createElementVNode("div", {
                                  class: "out_box",
                                  style: _normalizeStyle(
                      _ctx.isinline
                        ? 'border:2px solid #416BE2;background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                        : 'background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                    ),
                                  onFocusin: _cache[44] || (_cache[44] = ($event: any) => (_ctx.isinline = true)),
                                  onFocusout: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isinline = false))
                                }, [
                                  _createElementVNode("div", {
                                    class: "inputs step5",
                                    style: _normalizeStyle(
                        _ctx.isinline
                          ? 'border-color:transparent;'
                          : 'border-color:none'
                      )
                                  }, [
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.question) = $event)),
                                      onKeyup: _cache[41] || (_cache[41] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keydown3 && _ctx.keydown3(...args)), ["enter"])),
                                      ref: "inputText",
                                      placeholder: "在此输入您想了解的内容，输入“/”可查看当前机器人“shift+enter”换行",
                                      onInput: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.handleInput1 && _ctx.handleInput1(...args))),
                                      rows: "3"
                                    }, null, 544), [
                                      [_vModelText, _ctx.question]
                                    ]),
                                    _createElementVNode("div", {
                                      class: "subbtn",
                                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.sendmessage2()))
                                    }, _hoisted_160)
                                  ], 4)
                                ], 36)
                              ]),
                              _createElementVNode("div", _hoisted_161, [
                                (_ctx.homemaskname != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                      _hoisted_163,
                                      _createElementVNode("img", {
                                        style: {"width":"22px","height":"22px","border-radius":"50%","margin-right":"10px"},
                                        src: _ctx.origin + _ctx.homemasklogo,
                                        alt: ""
                                      }, null, 8, _hoisted_164),
                                      _createTextVNode(_toDisplayString(_ctx.homemaskname) + " ", 1),
                                      _createElementVNode("div", {
                                        class: "close",
                                        onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.clearhomeask && _ctx.clearhomeask(...args)))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Minus)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_165, _hoisted_167))
                              ]),
                              _createElementVNode("div", _hoisted_168, [
                                _hoisted_169,
                                _createElementVNode("div", _hoisted_170, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.maskList, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(_ctx.homemaskactive == index ? 'active' : ''),
                                      key: index,
                                      onClick: ($event: any) => (_ctx.showhide(index))
                                    }, _toDisplayString(item.name), 11, _hoisted_171))
                                  }), 128))
                                ]),
                                (_ctx.robot.maskList)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.maskList[_ctx.homemaskactive]
                        .masks, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_tooltip, {
                                          effect: "light",
                                          class: "box-item",
                                          placement: "bottom",
                                          key: index
                                        }, {
                                          content: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_173, _toDisplayString(item.describe), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              class: "card_select_item",
                                              "data-id": item.id,
                                              "data-type": "robot",
                                              onClick: ($event: any) => (_ctx.homemaskselect(item))
                                            }, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_el_avatar, {
                                                  size: 60,
                                                  src: _ctx.origin + item.logo
                                                }, null, 8, ["src"])
                                              ]),
                                              _createElementVNode("p", _hoisted_175, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_176, _toDisplayString(item.describe), 1),
                                              _hoisted_177
                                            ], 8, _hoisted_174)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.robot.myrobotList.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                    _hoisted_179,
                                    _createElementVNode("div", _hoisted_180, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.myrobotList, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_tooltip, {
                                          effect: "light",
                                          class: "box-item",
                                          placement: "bottom",
                                          key: index
                                        }, {
                                          content: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_181, _toDisplayString(item.describe), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              class: "card_select_item",
                                              "data-id": item.id,
                                              "data-type": "robot",
                                              onClick: ($event: any) => (_ctx.tab(item, 'create'))
                                            }, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_el_avatar, {
                                                  size: 60,
                                                  src: _ctx.origin + item.logo
                                                }, null, 8, ["src"])
                                              ]),
                                              _createElementVNode("p", _hoisted_183, _toDisplayString(item.name), 1),
                                              _createElementVNode("p", _hoisted_184, _toDisplayString(item.describe), 1)
                                            ], 8, _hoisted_182)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.token)
          ? (_openBlock(), _createBlock(_component_el_container, {
              key: 2,
              class: "container"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_185, [
                  _createVNode(_component_el_card, {
                    class: "box-card",
                    "body-class": "box-card-body",
                    style: {"width":"100%","background":"transparent","border":"none","box-shadow":"none","padding-top":"30px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_186,
                      _createElementVNode("div", _hoisted_187, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.modelslist, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(_ctx.homeactive == index ? 'active' : ''),
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.sendmessage3()))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.origin + item.logo,
                              alt: ""
                            }, null, 8, _hoisted_188),
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ], 2))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", {
                          class: "out_box",
                          style: _normalizeStyle(
                  _ctx.isinline
                    ? 'border:2px solid #416BE2;background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                    : 'background:#fff;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
                ),
                          onFocusin: _cache[52] || (_cache[52] = ($event: any) => (_ctx.isinline = true)),
                          onFocusout: _cache[53] || (_cache[53] = ($event: any) => (_ctx.isinline = false)),
                          onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.login()))
                        }, [
                          _createElementVNode("div", _hoisted_190, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.question) = $event)),
                              onKeyup: _cache[49] || (_cache[49] = _withKeys(
//@ts-ignore
(...args) => (_ctx.keydown2 && _ctx.keydown2(...args)), ["enter"])),
                              ref: "inputText",
                              placeholder: "欢迎来到畅聊",
                              onInput: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                              rows: "3"
                            }, null, 544), [
                              [_vModelText, _ctx.question]
                            ]),
                            _createElementVNode("div", {
                              class: "subbtn",
                              onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.sendmessage3()))
                            }, _hoisted_192)
                          ])
                        ], 36)
                      ]),
                      _hoisted_193
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.token)
          ? (_openBlock(), _createElementBlock("div", _hoisted_194, _hoisted_199))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.loginDialog,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.loginDialog) = $event)),
      title: "个人账号登录",
      width: "400px",
      "before-close": _ctx.handleClose2
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_200, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: "usernameinput",
                    placeholder: "请输入账号/用户名",
                    modelValue: _ctx.formLabelAlign.username,
                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.formLabelAlign.username) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入密码",
                    type: "password",
                    modelValue: _ctx.formLabelAlign.password,
                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.formLabelAlign.password) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    style: {"width":"100%"},
                    type: "primary",
                    onClick: _ctx.loginuser
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("登录")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_201, [
            _createElementVNode("span", {
              style: {"font-size":"12px","text-decoration":"underline","color":"#3468f7","cursor":"pointer"},
              onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.showRegisterModal && _ctx.showRegisterModal(...args)))
            }, "没有个人账号？点击注册")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.registerDialog,
      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.registerDialog) = $event)),
      title: "个人账号注册",
      width: "500px",
      "before-close": _ctx.handleClose2
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_202, [
          _createVNode(_component_el_form, {
            ref: "registerFormRef",
            rules: _ctx.rules,
            "label-width": "100px",
            model: _ctx.registerjson.list
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "账号/用户名",
                prop: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: "usernameinput",
                    placeholder: "请输入账号/用户名",
                    modelValue: _ctx.registerjson.list.username,
                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.registerjson.list.username) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "密码",
                    type: "password",
                    modelValue: _ctx.registerjson.list.password,
                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.registerjson.list.password) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "确认密码",
                prop: "repassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "确认密码",
                    type: "password",
                    modelValue: _ctx.registerjson.list.repassword,
                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.registerjson.list.repassword) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "邮箱",
                    modelValue: _ctx.registerjson.list.email,
                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.registerjson.list.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "phone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "手机号",
                    modelValue: _ctx.registerjson.list.phone,
                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.registerjson.list.phone) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "手机验证码",
                prop: "code"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "手机验证码",
                    modelValue: _ctx.registerjson.list.code,
                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.registerjson.list.code) = $event))
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _ctx.sendcode,
                        disabled: _ctx.isshowtimes
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isshowtimes ? _ctx.timess : "获取验证码"), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { "label-width": "0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_203, [
                    _createVNode(_component_el_button, {
                      style: {},
                      type: "primary",
                      onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.registeruser()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("注册")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.myrobotdialog,
      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.myrobotdialog) = $event)),
      width: "600px",
      "before-close": _ctx.handleClose2
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_204, [
          _createTextVNode(" 我的机器人"),
          _createElementVNode("span", null, _toDisplayString(Number(_ctx.robot.myrobotList.length) +
              Number(_ctx.robot.maskListcopylength) +
              Number(_ctx.robot.asideListlength)) + " 个", 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_205, [
          _createVNode(_component_el_collapse, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, { name: "1" }, {
                title: _withCtx(() => [
                  _createElementVNode("p", _hoisted_206, [
                    _createTextVNode(" 我创建的"),
                    _createElementVNode("span", null, _toDisplayString(_ctx.robot.myrobotList.length) + "个", 1)
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.myrobotList, (item, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "mychat",
                      style: {"border-bottom":"1px solid #ebeef5"},
                      "data-id": item.id,
                      "data-type": "robot",
                      key: index,
                      onClick: ($event: any) => (_ctx.tab(item))
                    }, [
                      _withDirectives(_createElementVNode("img", {
                        src: _ctx.origin + item.logo,
                        alt: ""
                      }, null, 8, _hoisted_208), [
                        [_vShow, item.logo]
                      ]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 8, _hoisted_207)), [
                      [_vShow, item.name]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, { name: "1" }, {
                title: _withCtx(() => [
                  _createElementVNode("p", _hoisted_209, [
                    _createTextVNode(" 应用场景"),
                    _createElementVNode("span", null, _toDisplayString(_ctx.robot.maskListcopylength) + "个", 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse, { accordion: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.maskListcopy, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_collapse_item, {
                          name: item.name,
                          key: index
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_210, [
                              _createElementVNode("p", _hoisted_211, [
                                _createTextVNode(_toDisplayString(item.name), 1),
                                _createElementVNode("span", null, _toDisplayString(item.num) + "个", 1)
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.masks, (items, indexs) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mychat",
                                "data-id": items.id,
                                "data-name": items.title,
                                "data-type": "mask",
                                key: indexs,
                                onClick: ($event: any) => (_ctx.masktab(items.id))
                              }, [
                                _withDirectives(_createElementVNode("img", {
                                  src: _ctx.origin + items.logo,
                                  alt: ""
                                }, null, 8, _hoisted_213), [
                                  [_vShow, items.logo]
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", null, [
                                    _createTextVNode(_toDisplayString(items.title) + " ", 1),
                                    _createElementVNode("span", null, _toDisplayString(items.num) + "个", 1)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(items.describe), 1)
                                ])
                              ], 8, _hoisted_212))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["name"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, { name: "1" }, {
                title: _withCtx(() => [
                  _createElementVNode("p", _hoisted_214, [
                    _createTextVNode(" 基础模型"),
                    _createElementVNode("span", null, _toDisplayString(_ctx.robot.asideListlength) + "个", 1)
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.asideList, (item, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "mychat",
                      style: {"border-bottom":"1px solid #ebeef5"},
                      "data-id": item.id,
                      "data-type": "robot",
                      key: index,
                      onClick: ($event: any) => (_ctx.tab(item))
                    }, [
                      _withDirectives(_createElementVNode("img", {
                        src: _ctx.origin + item.logo,
                        alt: ""
                      }, null, 8, _hoisted_216), [
                        [_vShow, item.logo]
                      ]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 8, _hoisted_215)), [
                      [_vShow, item.coll?.is_coll]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.maskselectdialog,
      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.maskselectdialog) = $event)),
      title: "选择模型",
      width: "300",
      "before-close": _ctx.handleClose2
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_217, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.modelslist, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(
            _ctx.selectrobotlist.list[0]?.name.split('-')[0] == item.name
              ? _ctx.selectrobotlist.list.length == 1
                ? 'gray'
                : ''
              : ''
          ),
              onClick: ($event: any) => (
            _ctx.selectrobotlist.list[0]?.name.split('-')[0] == item.name
              ? _ctx.selectrobotlist.list.length == 1
                ? ''
                : _ctx.addmaskmore(item.id)
              : _ctx.addmaskmore(item.id)
          )
            }, [
              (item.coll?.is_coll)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_StarFilled)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 10, _hoisted_218))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.drawer) = $event)),
      title: _ctx.adddialogname,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_219, [
          _createVNode(_component_el_avatar, {
            size: 50,
            src: _ctx.origin + _ctx.addavatar,
            onClick: _ctx.uploadimgs
          }, null, 8, ["src", "onClick"]),
          _createElementVNode("div", {
            onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.uploadimgs && _ctx.uploadimgs(...args)))
          }, "编辑头像")
        ]),
        _createElementVNode("div", _hoisted_220, [
          _hoisted_221,
          _createVNode(_component_el_input, {
            modelValue: _ctx.addrotname,
            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.addrotname) = $event)),
            placeholder: "请输入4-20个字符，可包含数字、字幕和特殊字符"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_222, [
          _hoisted_223,
          _createVNode(_component_el_select, {
            modelValue: _ctx.addrotmodel,
            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.addrotmodel) = $event)),
            placeholder: "选择大模型",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.robot.modelslist, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.name,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_224, [
          _hoisted_225,
          _hoisted_226,
          _createVNode(_component_el_input, {
            modelValue: _ctx.addrotprompt,
            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.addrotprompt) = $event)),
            type: "textarea",
            placeholder: "例如：你是烘焙师，你会以辛辣的方式回复每一条用户信息，不要在的回答中使用任何脏话或者粗俗的词语。",
            rows: "5"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_227, [
          _createElementVNode("div", null, [
            _hoisted_228,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.addrotswitch,
              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.addrotswitch) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_229, [
          _hoisted_230,
          _hoisted_231,
          _createVNode(_component_el_input, {
            modelValue: _ctx.addrotgreeting,
            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.addrotgreeting) = $event)),
            type: "textarea",
            placeholder: "例如：您好！我是智能图书馆员！",
            rows: "5"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_232, [
          _hoisted_233,
          _hoisted_234,
          _createVNode(_component_el_input, {
            modelValue: _ctx.adddescribe,
            "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.adddescribe) = $event)),
            type: "textarea",
            placeholder: "例如：您好！我是智能图书馆员！",
            rows: "5"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            type: "primary",
            onClick: _ctx.createRobot
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.adddialogname), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.lookpamartdialog,
      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.lookpamartdialog) = $event)),
      width: "30%",
      "before-close": _ctx.handleClose2
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_235, [
          _createElementVNode("img", {
            style: {"margin":"5px auto","text-align":"center","border-radius":"50%"},
            src: _ctx.origin + _ctx.infojson.json.logo,
            alt: ""
          }, null, 8, _hoisted_236),
          _createElementVNode("div", _hoisted_237, _toDisplayString(_ctx.infojson.json.name), 1),
          _createElementVNode("div", _hoisted_238, _toDisplayString(_ctx.infojson.json.prompt), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createElementVNode("div", _hoisted_239, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.openselectdialog,
        "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.openselectdialog) = $event)),
        title: "Tips",
        width: "1200px",
        "before-close": _ctx.handleCloseopen,
        "show-close": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_240, [
            _createElementVNode("div", _hoisted_241, [
              _hoisted_242,
              _createElementVNode("img", {
                onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.openselectdialog = false)),
                src: _imports_18,
                alt: "",
                class: "select-header-close",
                style: {"cursor":"pointer"}
              })
            ]),
            _createElementVNode("div", _hoisted_243, [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.myrose == 1 ? 'divactive' : ''),
                  onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.myrose = 1))
                }, " 我创建的 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.myrose == 2 ? 'divactive' : ''),
                  onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.myrose = 2))
                }, " 应用场景 ", 2)
              ]),
              _createElementVNode("div", _hoisted_244, [
                _hoisted_245,
                _createVNode(_component_el_input, {
                  style: {"margin":"0 10px 0 0"},
                  modelValue: _ctx.robotsearch,
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.robotsearch) = $event)),
                  clearable: "",
                  onClear: _ctx.robotsearchsub,
                  onKeyup: _withKeys(_ctx.robotsearchsub, ["enter"]),
                  placeholder: "输入机器人名称"
                }, null, 8, ["modelValue", "onClear", "onKeyup"])
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.myrose == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                  (_ctx.searchrobotlist.myrobotlist.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.robotselect,
                          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.robotselect) = $event)),
                          onChange: _ctx.getCouponSelected
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "访问量",
                              value: "visits"
                            }),
                            _createVNode(_component_el_option, {
                              label: "时间正序",
                              value: "create_time"
                            }),
                            _createVNode(_component_el_option, {
                              label: "时间倒叙",
                              value: "-create_time"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_248, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchrobotlist.myrobotlist, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "card_select_item",
                        onClick: ($event: any) => (_ctx.totab(item)),
                        key: index,
                        "data-id": item.id,
                        "data-type": "robot"
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_avatar, {
                            size: 60,
                            src: _ctx.origin + item.logo
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("p", _hoisted_250, _toDisplayString(item.name), 1),
                        _createElementVNode("p", _hoisted_251, _toDisplayString(item.describe), 1),
                        _createElementVNode("div", _hoisted_252, [
                          _createElementVNode("div", null, [
                            _hoisted_253,
                            _createTextVNode(_toDisplayString(item.visits), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_254,
                            _createTextVNode(_toDisplayString(item.create_time.split(" ")[0]), 1)
                          ])
                        ])
                      ], 8, _hoisted_249))
                    }), 128)),
                    (_ctx.searchrobotlist.myrobotlist.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_255, _hoisted_258))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.myrose == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                  (_ctx.searchrobotlist.alllist.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card_select_div_item", _ctx.homemaskactivedialog == 'all' ? 'active' : '']),
                          onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.showhidedia('all')))
                        }, " 全部 ", 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchrobotlist.masklist, (item, index) => {
                          return _withDirectives((_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["card_select_div_item", Number(_ctx.homemaskactivedialog) == index ? 'active' : '']),
                            key: index,
                            onClick: ($event: any) => (_ctx.showhidedia(index))
                          }, _toDisplayString(item.name), 11, _hoisted_261)), [
                            [_vShow, item.masks.length > 0]
                          ])
                        }), 128)),
                        _createVNode(_component_el_select, {
                          class: "step7",
                          modelValue: _ctx.robotselect,
                          "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.robotselect) = $event)),
                          onChange: _ctx.getCouponSelected
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "访问量",
                              value: "visits"
                            }),
                            _createVNode(_component_el_option, {
                              label: "时间正序",
                              value: "create_time"
                            }),
                            _createVNode(_component_el_option, {
                              label: "时间倒叙",
                              value: "-create_time"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchrobotlist.masklist && _ctx.homemaskactivedialog != 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchrobotlist.masklist[
                  _ctx.homemaskactivedialog
                ].masks, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "card_select_item",
                            style: {"margin-bottom":"10px"},
                            key: index,
                            "data-id": item.id,
                            "data-type": "robot"
                          }, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_avatar, {
                                size: 60,
                                src: _ctx.origin + item.logo
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("p", _hoisted_264, _toDisplayString(item.title), 1),
                            _createElementVNode("p", _hoisted_265, _toDisplayString(item.describe), 1),
                            _createElementVNode("div", _hoisted_266, [
                              _createElementVNode("div", null, [
                                _hoisted_267,
                                _createTextVNode(_toDisplayString(item.visits), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_268,
                                _createTextVNode(_toDisplayString(item.create_time.split(" ")[0]), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "card_select_item_btns",
                              onClick: ($event: any) => (_ctx.homemaskselect(item))
                            }, " 添加为机器人 ", 8, _hoisted_269)
                          ], 8, _hoisted_263))
                        }), 128)),
                        (
                  _ctx.searchrobotlist.masklist[_ctx.homemaskactivedialog].masks.length ==
                  0
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_270, _hoisted_273))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchrobotlist.alllist && _ctx.homemaskactivedialog == 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchrobotlist.alllist, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "card_select_item",
                            style: {"margin-bottom":"10px"},
                            key: index,
                            "data-id": item.id,
                            "data-type": "robot"
                          }, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_avatar, {
                                size: 60,
                                src: _ctx.origin + item.logo
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("p", _hoisted_276, _toDisplayString(item.title), 1),
                            _createElementVNode("p", _hoisted_277, _toDisplayString(item.describe), 1),
                            _createElementVNode("div", _hoisted_278, [
                              _createElementVNode("div", null, [
                                _hoisted_279,
                                _createTextVNode(_toDisplayString(item.visits), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_280,
                                _createTextVNode(_toDisplayString(item.create_time.split(" ")[0]), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "card_select_item_btns",
                              onClick: ($event: any) => (_ctx.homemaskselect(item))
                            }, " 添加为机器人 ", 8, _hoisted_281)
                          ], 8, _hoisted_275))
                        }), 128)),
                        (_ctx.searchrobotlist.alllist.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_282, _hoisted_285))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"])
    ]),
    _createElementVNode("div", _hoisted_286, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.versiondialog,
        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.versiondialog) = $event)),
        title: "Tips",
        width: "1200px",
        "before-close": _ctx.handleCloseopen,
        "show-close": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_287, [
            _createElementVNode("div", _hoisted_288, [
              _hoisted_289,
              _createElementVNode("img", {
                onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.versiondialog = false)),
                src: _imports_18,
                alt: "",
                class: "select-header-close",
                style: {"cursor":"pointer"}
              })
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_card, { style: {"max-height":"60vh","overflow":"auto"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_290, [
                  _createElementVNode("span", _hoisted_291, _toDisplayString(_ctx.version.list.title), 1),
                  _createElementVNode("span", _hoisted_292, "更新时间：" + _toDisplayString(_ctx.version.list.online_time), 1)
                ]),
                _createElementVNode("div", _hoisted_293, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.version.list.content
                  }, null, 8, _hoisted_294)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"]),
      _createVNode(_component_el_dialog, {
        class: "register-guide-dialog",
        modelValue: _ctx.registerGuideModal,
        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.registerGuideModal) = $event)),
        title: "",
        width: "400px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_295, [
            _hoisted_296,
            _hoisted_297,
            _createVNode(_component_el_image, {
              style: {"width":"100%"},
              src: require('@/assets/img/register_1.png'),
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              "preview-src-list": [require('@/assets/img/register_1.png')],
              "initial-index": 4,
              fit: "cover"
            }, null, 8, ["src", "preview-src-list"]),
            _hoisted_298,
            _createVNode(_component_el_image, {
              style: {"width":"100%"},
              src: require('@/assets/img/register_2.png'),
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              "preview-src-list": [require('@/assets/img/register_2.png')],
              "initial-index": 4,
              fit: "cover"
            }, null, 8, ["src", "preview-src-list"]),
            _hoisted_299,
            _createVNode(_component_el_image, {
              style: {"width":"100%"},
              src: require('@/assets/img/register_3.png'),
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              "preview-src-list": [require('@/assets/img/register_3.png')],
              "initial-index": 4,
              fit: "cover"
            }, null, 8, ["src", "preview-src-list"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 512))
}